import { INSURANCE_COMPANIES_PERIOD_FILTER_EVENTS } from './global-events';

export const insuranceCompaniesPeriodCalendarEventMap = {
  'range-selected': INSURANCE_COMPANIES_PERIOD_FILTER_EVENTS.INSURANCE_COMPANIES_PERIOD_FILTER_DATES_RANGE,
};

export const insuranceCompaniesPeriodFilterOptions = [
  {
    id: 'current_month',
    name: 'Поточний місяць',
    event: INSURANCE_COMPANIES_PERIOD_FILTER_EVENTS.INSURANCE_COMPANIES_PERIOD_FILTER_CURRENT_MONTH,
    options: {
      type: 'checkbox',
      activeFilter: false,
    },
  },
  {
    id: 'months',
    name: 'Місяць',
    event: INSURANCE_COMPANIES_PERIOD_FILTER_EVENTS.INSURANCE_COMPANIES_PERIOD_FILTER_MONTH,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'weeks',
    name: 'Тиждень',
    event: INSURANCE_COMPANIES_PERIOD_FILTER_EVENTS.INSURANCE_COMPANIES_PERIOD_FILTER_WEEK,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'days',
    name: 'День',
    event: INSURANCE_COMPANIES_PERIOD_FILTER_EVENTS.INSURANCE_COMPANIES_PERIOD_FILTER_DAY,
    options: {
      type: 'checkbox',
    },
  },
];
